import { render, staticRenderFns } from "./ChessCommerce.vue?vue&type=template&id=58ecb06c&"
import script from "./ChessCommerce.vue?vue&type=script&lang=js&"
export * from "./ChessCommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports